import { Link } from "react-router-dom";
import styles from "./Footer.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import epyxLogo from "application/images/epyxWht.svg";
import corpayLogo from "application/images/corpayLogo.png";

const Footer = () => {
  const layoutState = useSelector((state: RootState) => state.layout);
  const { data, error } = layoutState;

  if (error) return <p>Error: {error}</p>;
  if (!data || !data.footerLinks) return null;

  return (
    <footer className={`${styles.footer} py-2`}>
      <div className="d-flex align-items-center w-100 px-4 flex-sm-row flex-column">
        <img src={epyxLogo} alt="epyx Logo" height="40" />
        <div className="align-items-start flex-grow-1 px-3">
          <div className="flex-wrap align-items-center">
            <span className={`${styles.copyright} me-2`}>
              {data.footerCopyright}
            </span>

            {data.footerLinks.map(({ title, url }: { title: string; url: string }, idx: number) => {
              const isPdf = url.toLowerCase().includes(".pdf");

              if (isPdf) {
                return (
                  <a
                    key={idx}
                    href={`${process.env.PUBLIC_URL}/${url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${styles.footerLink} me-2`}
                  >
                    {title}
                  </a>
                );
              }

              return (
                <Link to={url} key={idx} className={`${styles.footerLink} me-2`}>
                  {title}
                </Link>
              );
            })}

          </div>
          <div className={`mt-2 ${styles.helpText}`}>
            {data.footerHelpText}
          </div>
        </div>
        <img src={corpayLogo} alt="corpay Logo" height="20" className="mt-2" />
      </div>
    </footer>
  );
};

export default Footer;
